import { IExportBehavior, ILayerBehavior, LayerType } from '@/version-types';
import { createFontBehaviors } from './behaviors/font';
import { createOperationBehaviors } from './behaviors/operation';
import { createRendererBehaviors } from './behaviors/renderer';
import { createSaveBehaviors } from './behaviors/save';
import { SIDE_BAR_BOLD } from './default-configs';

const getBehavior = (frameworkIdentity: string) => {
    const rendererBehaviors = createRendererBehaviors(frameworkIdentity);
    const operationBehaviors = createOperationBehaviors(frameworkIdentity);
    const fontBehaviors = createFontBehaviors(frameworkIdentity);
    const saveBehaviors = createSaveBehaviors(frameworkIdentity);

    const layerBehavior: ILayerBehavior = {
        ...rendererBehaviors,
        ...operationBehaviors,
        ...fontBehaviors,
        ...saveBehaviors,
        checkDisableFlip() {
            return true;
        },
        shortcutMenuOffsetY() {
            return SIDE_BAR_BOLD;
        },
    };

    return layerBehavior;
};

export default {
    layerType: LayerType.TABLE,
    getBehavior,
} as IExportBehavior;
